import React, { useEffect, useState } from "react";
import { ReactComponent as IconClose } from "components/icons/icon-close.svg";
import { Button, IconLinkButton } from "../components/buttons";
import axios from "axios";
import Platform from "react-platform-js";

interface FormData {
	name: string;
	email: string;
	message: string;
	osVersion: string | undefined;
	deviceMake: string;
	deviceModel: string;
	browserName: string;
	browserVersion: string;
}

interface Errors {
	name?: string;
	email?: string;
	message?: string;
}

const ContactPage = () => {
	const [formData, setFormData] = useState<FormData>({
		name: "",
		email: "",
		message: "",
		osVersion: "",
		deviceMake: "",
		deviceModel: "",
		browserName: "",
		browserVersion: ""
	});
	const [isLoading, setIsLoading] = useState(false);
	const [showAlert, setShowAlert] = useState(false);
	const [errors, setErrors] = useState<Errors>({});

	 
	// Get Device & Browser Information
	useEffect(() => {
		let deviceInfo: string = "";

		if(Platform.DeviceModel === undefined || Platform.DeviceType === undefined) {
			deviceInfo = "Not Available" 
		} else {
			deviceInfo = Platform.DeviceModel+" "+Platform.DeviceType
		}

		// Update state
		setFormData(prevState => ({
			...prevState,
			osVersion: Platform.OS + " " + Platform.OSVersion,
			deviceMake: Platform.DeviceVendor !== undefined ? Platform.DeviceVendor : "Not Available",
			deviceModel: deviceInfo,
			browserName: Platform.Browser,
			browserVersion: Platform.BrowserVersion
		}));
	}, []);

	const validate = () => {
		let newErrors: Errors = {};

		if (!formData.name.trim()) newErrors.name = "Name is required";
		if (!formData.email.trim()) newErrors.email = "Email is required";
		else if (!/\S+@\S+\.\S+/.test(formData.email))
			newErrors.email = "Invalid email format";
		if (!formData.message.trim()) newErrors.message = "Message is required";

		setErrors(newErrors);
		return Object.keys(newErrors).length === 0;
	};

	// Handle input change
	const handleChange = (
		event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
	) => {
		const { name, value } = event.target;
		setFormData(prevData => ({
			...prevData,
			[name]: value
		}));
	};

	const handleSubmit = async (e: React.FormEvent) => {
		e.preventDefault();
		if (!validate()) {
			return 0;
		}
		setIsLoading(true);
		try {
			const apiUrl = process.env.REACT_APP_SERVER_URL;
			await axios
				.post("https://ckua.com/mail-app/send-mail.php", {
					...formData
				})
				.then(() => {
					setShowAlert(true);
					setFormData({ ...formData, name: "", email: "", message: "" });
				})
				.finally(() => {
					setIsLoading(false);
				});
		} catch (error) {
			console.log(error);
			console.error("Error sending message.");
		}
	};
	return (
		<React.Fragment>
			<div className="bg-secondary banner-border-radius">
				<div className="container d-flex align-items-center align-items-center justify-content-between mb-2 pt-3 pt-lg-4 pb-3">
					<h3 className="mb-0 text-dark">Contact Us</h3>
					<IconLinkButton className="text-dark m-0 me-n2 p-2" to="/">
						<IconClose className="icon-size-lg" />
					</IconLinkButton>
				</div>
			</div>
			<div className="container mt-n7">
				<div className="row mt-4 min-vh-100">
					<div className="col-lg-12 mt-8">
						{showAlert && (
							<div
								className="alert alert-success alert-dismissible fade show mt-3"
								role="alert"
							>
								<span style={{ color: "green" }}>
									<strong>Success!</strong> Your message has been sent.
								</span>
								<button
									type="button"
									className="btn-close"
									data-bs-dismiss="alert"
									aria-label="Close"
									onClick={() => setShowAlert(false)}
								/>
							</div>
						)}
						<form>
							<div className="form-group mb-4">
								<label htmlFor="name" className="fw-light">
									Name*
								</label>
								<input
									type="email"
									className="form-control container border-0 no-outline"
									id="name"
									placeholder="Name"
									name="name"
									value={formData.name}
									onChange={handleChange}
								/>
								{errors.name && (
									<small className="text-danger">{errors.name}</small>
								)}
							</div>

							<div className="form-group mb-4">
								<label htmlFor="email" className="fw-light">
									Email address*
								</label>
								<input
									type="email"
									className="form-control container border-0 no-outline"
									placeholder="Email Address"
									name="email"
									value={formData.email}
									onChange={handleChange}
									id="email"
								/>
								{errors.email && (
									<small className="text-danger">{errors.email}</small>
								)}
							</div>

							<div className="form-group mb-3">
								<label htmlFor="message" className="fw-light">
									Please provide a detailed description of the issue*
								</label>
								<textarea
									className="form-control container border-0 no-outline"
									placeholder="Message"
									value={formData.message}
									name="message"
									onChange={handleChange}
									id="message"
									rows={5}
								/>
								{errors.message && (
									<small className="text-danger">{errors.message}</small>
								)}
							</div>
							<Button
								onClick={handleSubmit}
								className="btn-secondary text-grey fw-light"
							>
								{isLoading ? (
									<>
										<span
											className="spinner-border spinner-border-sm me-2"
											role="status"
											aria-hidden="true"
										/>
										Sending...
									</>
								) : (
									"Send"
								)}
							</Button>
						</form>
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default ContactPage;
